module.exports = __webpack_public_path__ + "static/media/return-to-fertility-silhouette@2x.d28b1461.png";